/**
 * État vide : ce qu'affiche un écran quand il n'a rien à montrer.
 *
 * Les messages du CRM se contentaient de constater — « Aucun contrat
 * enregistré ». Exact, mais la personne devant l'écran se demande alors si
 * c'est normal, si c'est cassé, et ce qu'elle doit faire.
 *
 * Un état vide utile répond aux trois questions : ce qui manque, à quoi sert
 * cet écran, et l'action suivante. Chez un courtier qui découvre le CRM avec
 * une base neuve, ces écrans sont l'essentiel de ce qu'il voit — ils tiennent
 * lieu de mode d'emploi, que personne ne lit.
 *
 * Ne s'affiche jamais quand il y a des données : un cabinet en activité ne le
 * verra que sur les sections réellement vides.
 */
import React from 'react';
import { C, E, T } from '../theme';

export default function EtatVide({ titre, description, action, compact }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      textAlign: 'center', gap: E.sm,
      padding: compact ? `${E.xl} ${E.lg}` : `${E.xxl} ${E.lg}`,
    }}>
      <div style={{ fontSize: '14px', fontWeight: 600, color: C.texte }}>
        {titre}
      </div>
      {description && (
        <div style={{ fontSize: '13px', color: C.texteFaible, maxWidth: 380,
                      lineHeight: 1.5 }}>
          {description}
        </div>
      )}
      {action && <div style={{ marginTop: E.sm, display: 'flex', gap: E.sm,
                               flexWrap: 'wrap', justifyContent: 'center' }}>{action}</div>}
    </div>
  );
}

/** Variante en une ligne, pour une section à l'intérieur d'une fiche. */
export function EtatVideLigne({ children }) {
  return (
    <div style={{ ...T.corps, color: C.texteFaible, fontSize: '13px',
                  fontStyle: 'normal' }}>
      {children}
    </div>
  );
}
